import React from "react";
import styled from "styled-components";
import NextImage from "next/image";

import { FlexDiv } from "@/components/Atoms/Box";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V1";

function IconText(props) {
  return (
    <Wrapper flex={"1"}>
      {props.data?.map((item, index) => {
        return (
          <IconWrap key={index}>
            <IconRing>
              <NextImage
                src={item.image}
                alt={item.title}
                fill={true}
                style={{ objectFit: "cover" }}
              />
            </IconRing>
            <TextWrap flexDirection={"column"}>
              <Typography
                mb={"7px"}
                variant="title2"
                fontSize={"16px"}
                color={theme.colors.link2Color}
              >
                {item.title}
              </Typography>
              <Typography variant="paragraph2" color={theme.colors.gray_100}>
                {item.subtitle}
              </Typography>
            </TextWrap>
          </IconWrap>
        );
      })}
    </Wrapper>
  );
}

export default IconText;
const Wrapper = styled(FlexDiv)`
  padding: 81px 0 0 0;
  flex-wrap: wrap;
  @media only screen and (max-width: 1169px) {
    padding: 50px 0 50px 0;
    background-color: ${theme.colors.lightBlue};
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    padding: 30px 0 30px 0;
  }
`;
const IconWrap = styled(FlexDiv)`
  width: 100%;
  max-width: 25%;
  padding: 0 15px;
  flex-direction: column;
  @media only screen and (max-width: 1169px) {
    max-width: 50%;
    flex: 0 0 50%;
    align-items: center;
    text-align: center;
    &:nth-child(-n + 2) {
      margin-bottom: 25px;
    }
  }
  @media only screen and (max-width: 767px) {
    max-width: 100%;
    flex: 0 0 100%;
    flex-direction: row;
    align-items: center;
    text-align: center;
    margin-bottom: 18px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
const IconRing = styled(FlexDiv)`
  position: relative;
  background-color: ${theme.colors.shadeRed};
  height: 170px;
  width: 170px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.border4};
  margin-bottom: 15px;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 992px) {
    max-height: 108px;
    max-width: 108px;
  }
  @media only screen and (max-width: 767px) {
    margin-bottom: 0;
    margin-right: 25px;
  }
  @media only screen and (max-width: 359px) {
    max-height: 80px;
    max-width: 80px;
  }
`;
const TextWrap = styled(FlexDiv)`
  @media only screen and (max-width: 767px) {
    text-align: left;
    flex: 1;
  }
`;
